import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_friend.png"
import emptyWechat from "assets/images/ugifts/icons/empty/empty_wechat.png"

// import images
import iconPaymentSuccess from "assets/images/ugifts/icons/checkout/icon_payment_success.png"
import iconPaymentFailed from "assets/images/ugifts/icons/checkout/icon_payment_failed.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

function isWechat() {
  if (
    navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
    typeof navigator.wxuserAgent !== "undefined"
  ) {
    return true
  } else return false
}

const PrivacyPolicy = () => {
  const query = useQuery()
  const history = useHistory()
  const isWechatBrowser = isWechat()

  const [token, setToken] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Support | Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "white",
                  // paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    {
                      <Row
                        className="m-0 w-100"
                        style={{
                          height: "56px",
                          backgroundColor: "#009FE2",
                          position: "fixed",
                          top: 0,
                          zIndex: 1030,
                          maxWidth: "480px",
                        }}
                      >
                        <Col xs={2} className="ps-0">
                          {/* <Link to="/categories"> */}
                          {/* <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button> */}
                          {/* </Link> */}
                        </Col>
                        <Col xs={8} className="align-self-center">
                          <p className="h-100 text-white font-size-15 my-auto text-center">
                            {"Ugift Global Supports"}
                          </p>
                        </Col>
                        <Col xs={2} className="pe-0">
                          {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                        </Col>
                      </Row>
                    }
                    <Row className="p-3">
                      <Col>
                        <Card className="bg-primary text-white p-3">
                          <CardTitle>
                            Please contact us with below Email if you met any
                            issues, our support will reply you as soon as we
                            can.
                          </CardTitle>
                          <button
                            // to={"/home"}
                            className="btn btn-outline-light font-size-18 text-white mt-3"
                            // style={{ height: "42px" }}
                            onClick={() => {}}
                          >
                            <i className="bx bx-mail-send align-middle font-size-20 text-white me-2" />
                            {"ugiftsupport@e-buy.com"}
                          </button>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PrivacyPolicy
